import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteProject } from "../api/projects";

export function useDeleteProject() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteProject,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["projects"] }),
  });
}
